import "./avatar.css";
import { Avatar } from './avatar';
export default Avatar;